export default __webpack_public_path__ + "static/media/regulatory--triple-lanes--g1.5f11c2cf.png";